module.exports = __webpack_public_path__ + "static/img/clbgbox_1.39789aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/B1/clbgbox_1.png
// module id = bEv8
// module chunks = 0